module.exports = __webpack_public_path__ + "img/CS-Hybrid_Overview-Front_2.130c1353.jpg";